import { useEffect } from "react";
import PageHeader from "@/components/marketing/PageHeader";
import Careers from "@/components/marketing/Careers";
import Reveal from "@/components/Reveal";
import { CAREER_OPENINGS, IMG } from "@/data/content";
import { BTN_PRIMARY } from "@/lib/ui";
import { trackEvent } from "@/lib/tracking";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CareersPage() {
  useEffect(() => {
    trackEvent("page_view", { label: "careers" });
  }, []);

  return (
    <div data-testid="careers-page">
      <PageHeader
        overline="Careers at Ranger"
        crumb="Careers"
        title="Build Florida’s Future – Advance Your Career With Ranger"
        subtitle="Competitive pay, premier benefits, and long-term career growth in heavy civil construction."
        image={IMG.careersBanner}
        imagePosition="object-[50%_22%]"
      />

      <section className="bg-white py-10 border-b border-black/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-wrap gap-3">
          <Link to="/careers/culture-benefits" className="bg-rc-charcoal text-white rounded-full px-6 py-3 font-bold">Explore Culture & Benefits</Link>
          <Link to="/careers/open-positions" className="border border-rc-red text-rc-red rounded-full px-6 py-3 font-bold">View Open Positions</Link>
        </div>
      </section>

      <Careers />

      <section className="bg-rc-charcoal py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Reveal className="mb-12 flex flex-col md:flex-row md:items-end justify-between gap-6">
            <div>
              <div className="font-mono text-rc-sand text-xs uppercase tracking-[0.3em] mb-4">Now Hiring</div>
              <h2 className="font-heading font-black text-white text-[clamp(1.8rem,4vw,3rem)] leading-tight">
                Current openings by location.
              </h2>
            </div>
            <a
              href="https://careers.rangerconstruction.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="careers-page-apply"
              className={BTN_PRIMARY}
            >
              Apply Online <ArrowUpRight size={17} />
            </a>
          </Reveal>

          <div className="grid md:grid-cols-3 gap-5">
            {CAREER_OPENINGS.map((loc, i) => (
              <Reveal key={loc.location} delay={i * 0.08} className="bg-white/5 border border-white/10 rounded-2xl p-7">
                <div className="flex items-center gap-2 text-rc-red font-heading font-bold text-lg mb-4">
                  <MapPin size={18} /> {loc.location}
                </div>
                <ul className="space-y-2">
                  {loc.roles.map((r) => (
                    <li key={r} className="text-white/75 text-sm flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-rc-sand rounded-full" /> {r}
                    </li>
                  ))}
                </ul>
              </Reveal>
            ))}
          </div>
          <p className="text-white/40 text-sm mt-8 font-mono">
            Check back regularly for new positions · Submit your resume to hr@rangerconstruction.com
          </p>
        </div>
      </section>
    </div>
  );
}
